export default __webpack_public_path__ + "static/media/spin-bg-9.c4dbbc93.png";